import { useMemo } from 'react';
import { Web3ModalProvider } from "../Web3Modal";
import { ThemeProvider } from "../context/theme";
import BuilderGpt from "../screens/builder-gpt";

const useQuery = () => {
  return useMemo(() => {
    return new URLSearchParams(window.location.search);
  }, []);
};

function AppComponent({
  agents,
  darkMode,
  style,
}: {
  agents?: string[];
  darkMode?: boolean;
  style?: any;
}) {
  const query = useQuery();
  const agentsFromUrl = query.get("agents")?.split(",") ?? [];
  const darkModeFromUrl = query.get('darkMode');
  let appDarkMode = darkMode ?? true;
  if (darkModeFromUrl) {
    appDarkMode = darkModeFromUrl === 'true';
  }
  return (
    <div style={{ ...(style || {}) }}>
      <Web3ModalProvider>
        <ThemeProvider>
          <BuilderGpt
            agents={agentsFromUrl ? agentsFromUrl : (agents || [])}
            darkMode={appDarkMode}
          />
        </ThemeProvider>
      </Web3ModalProvider>
    </div>
  );
}

export { AppComponent };